
import Vue from 'vue';
import ILocation from '../../interfaces/ilocation';
import {mapGetters} from 'vuex';

declare const Alkami: any;

export default Vue.extend({
  name: 'location-details',
  data() {
    return {
      Alkami,
      selectedLocation: {} as ILocation
    };
  },
    computed: {
      ...mapGetters(['getSelectedLocation'])
  },
  async mounted() {
    this.selectedLocation = this.getSelectedLocation;
  }
});
